"use client"

import { ListMusic } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ListMusicIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ListMusicIcon = component(Icon)({ as: ListMusic })
